import styled from 'styled-components'
import { Styles as BaseStyles } from '~/pages/anatomy/libs/multipleChoiceStyles'
import { Option } from '~/shared/components/Option'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  ...BaseStyles,

  StyledOption: styled(Option)`
    max-width: 100%;
    margin: 0 auto;
    border-radius: 12px;
    padding: 16px 12px;

    &:not(:last-of-type) {
      margin-bottom: 12px;
    }
  `,

  Value: styled.p`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
    max-width: 100%;
  `,

  OptionIcon: styled.span`
    font-size: 22px;
    line-height: 1;
  `,

  ValueText: styled.span`
    font-weight: 700;
  `,
} as const
